<template>
  <div class="section-container">
    <div class="d-flex justify-space-between">
      <header-title-two
        :loading="isLoading"
        title="Live 101 Trainings"
        loaderClass="mb-lg-4"
      />
      <template v-if="live101Trainings.length > 0">
        <previous-next-navigation
          :navIndex="live101Slide"
          :navLast="live101Trainings.length - numberOfSlides"
          v-on:on-prev="onNav('prev')"
          v-on:on-next="onNav('next')"
          class-name="align-center prev-nav justify-end"
        />
      </template>
    </div>
    <skeleton-card-list
      type="avatar"
      :loading="isLoading"
      :isCard="true"
      :number="numberOfSlides"
      direction="horizontal"
      class="mt-4 skeleton-methodology flex-nowrap flex-lg-wrap"
    >
      <div class="content">
        <slick-carousel
          v-if="live101Trainings.length > 0"
          ref="slickCarousel"
          :itemsToShow="numberOfSlides"
          :settings="slickSettings"
          @afterChange="afterChange"
        >
          <card-two
            v-for="item in live101Trainings"
            v-bind:key="item.id"
            :id="item.id"
            :title="item.title"
            :description="item.description"
            :file="item.url"
            button-text="Register"
          />
        </slick-carousel>
      </div>
    </skeleton-card-list>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Live101TrainingsApi } from '@gslc/models';
import { openApiConfig } from '../../api/config';
import HeaderTitleTwo from '../../components/typography/header-title-2.vue';
import PreviousNextNavigation from '../../components/PreviousNextNavigation.vue';
import SkeletonCardList from '../../components/skeleton/CardList.vue';
import CardTwo from '../../components/cards/card-2.vue';
import SlickCarousel from '../../components/carousel/SlickCarousel.vue';
import { defaultSlickSettings, getNumberOfSlides } from '../../utils/carousel';

const config = openApiConfig();

const live101TrainingsApi = new Live101TrainingsApi(config);
export default {
  components: {
    HeaderTitleTwo,
    PreviousNextNavigation,
    SkeletonCardList,
    CardTwo,
    SlickCarousel,
  },
  data: () => ({
    isLoading: false,
    live101Slide: 0,
    slickSettings: defaultSlickSettings([3, 3.5, 2, 2, 1.2]),
  }),
  computed: {
    ...mapGetters(['live101Trainings', 'windowWidth']),
    numberOfSlides () {
      return getNumberOfSlides(this.windowWidth, [1.2, 2, 2, 3.5, 3]);
    }
  },
  mounted() {
    this.fetchLive101Trainings();
  },
  methods: {
    ...mapActions(['refreshLive101Trainings']),
    async fetchLive101Trainings() {
      this.isLoading = true;
      const accessToken = await this.$auth.getTokenSilently();
      const live101Trainings = await live101TrainingsApi
        .getLive101Trainings({
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .catch(e => console.error(e));
      this.refreshLive101Trainings(live101Trainings?.data?.data ?? []);
      this.isLoading = false;
    },
    afterChange(slideNumber) {
      this.live101Slide = slideNumber;
    },
    onNav(type) {
      switch (type) {
        case 'prev':
          this.$refs.slickCarousel.$children[0].prev();
          break;
        case 'next':
        default:
          this.$refs.slickCarousel.$children[0].next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  overflow: auto;
  width: calc(100% + 8px);
}
</style>
